// extracted by mini-css-extract-plugin
module.exports = {"otmfpu7":"otmfpu7","w192eflb":"w192eflb","ohu97qs":"ohu97qs","t1jfxdgt":"t1jfxdgt","an8t860":"an8t860"};